import gsap from "gsap";

// Facilities map: the open region's locations are shown at full opacity and the
// other regions' locations are dimmed; with no region open all are at full opacity.
const regionGroups = document.querySelectorAll( "svg#facility-map g.region" );

const DIMMED_OPACITY = 0.6;

function showRegion ( region ) {
  regionGroups.forEach( ( regionGroup ) => {
    const active = !region || regionGroup.dataset.g === region;

    // Fade the whole group at once: fading each piece (box, border, text, dots)
    // separately makes overlapping pieces show through each other.
    gsap.to( regionGroup, {
      opacity: active ? 1 : DIMMED_OPACITY,
      duration: 0.2,
    } );
  } );
}

document.querySelectorAll( ".locations-accordion" ).forEach( ( group ) => {
  group.querySelectorAll( ".accordion-item" ).forEach( ( item ) => {
    item.querySelector( ".accordion-toggle" ).addEventListener( "click", () => {
      // accordion.js updates the "active" class in its own click handler; read the result after it ran.
      setTimeout( () => {
        const active = group.querySelector( ".accordion-item.active" );
        if ( active ) {
          // Its height was measured while the panel was still hidden (0), so measure it again.
          const content = active.querySelector( ".accordion-content" );
          content.style.height = content.scrollHeight + "px";
        }
        showRegion( active ? active.dataset.g : null );
      }, 0 );
    } );
  } );
} );

document.querySelectorAll( ".locations-accordion" ).forEach( ( group ) => {
  // Initial state follows the region that is open on load (United States by default).
  const open = group.querySelector( ".accordion-item.active" );
  showRegion( open ? open.dataset.g : null );
} );
